import type { AuthEvent, AuthEventListener } from "@axio/auth";
import { authClient } from "../auth/client";

export type { AuthEvent };

export const subscribeAuthEvents = (listener: AuthEventListener): (() => void) => {
  return authClient.subscribe(listener);
};
